import { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "./ui/button";
import { Eraser } from "lucide-react";

export default function SignaturePad({ label, value, onChange, testid }) {
  const ref = useRef(null);
  const loaded = useRef(false);

  // Load an existing signature (e.g. when editing a saved report) into the
  // canvas once, so it can still be edited rather than replaced by an image.
  useEffect(() => {
    if (!loaded.current && value && ref.current) {
      try {
        ref.current.fromDataURL(value);
      } catch (e) {}
      loaded.current = true;
    }
  }, [value]);

  // Fires after every stroke — the canvas keeps ALL strokes, so lifting the
  // pen between strokes (e.g. writing initials) works correctly.
  const end = () => {
    if (ref.current && !ref.current.isEmpty()) {
      onChange(ref.current.toDataURL("image/png"));
    }
  };

  const clear = () => {
    ref.current?.clear();
    loaded.current = true; // prevent re-loading the old signature
    onChange("");
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-slate-700">{label}</span>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={clear}
          data-testid={`${testid}-clear`}
          className="h-8 text-slate-500"
        >
          <Eraser className="h-4 w-4 mr-1" /> Clear
        </Button>
      </div>
      <div className="rounded-lg border-2 border-dashed border-slate-300 bg-white overflow-hidden">
        <SignatureCanvas
          ref={ref}
          penColor="#111827"
          canvasProps={{ className: "sig-canvas", "data-testid": testid }}
          onEnd={end}
        />
      </div>
      <p className="text-xs text-slate-400">Sign above — you can lift the pen between strokes. Tap Clear to start again.</p>
    </div>
  );
}
